import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translation files
import translationSK from './locales/sk.json';
import translationCZ from './locales/cz.json';
import translationEN from './locales/en.json';
import translationDE from './locales/de.json';
import translationNL from './locales/nl.json';

const resources = {
  sk: { translation: translationSK },
  cz: { translation: translationCZ },
  en: { translation: translationEN },
  de: { translation: translationDE },
  nl: { translation: translationNL }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'sk',
    debug: false,
    
    interpolation: {
      escapeValue: false
    },
    
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage']
    }
  });

export default i18n;
